import axios from 'axios'
import router from '../router'
import Message from 'element-ui/packages/message'

// axios.defaults.baseURL = 'http://118.195.198.56:8000/'
axios.defaults.timeout = 10000
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 请求拦截
axios.interceptors.request.use(config => {
    let token = sessionStorage.getItem('token') || ''
    config.headers.token = token
    console.log('request', config)
    return config
}, err => {
    console.log('request-err', err)
    Message.error({
        message: '网络超时'
    })
    return Promise.reject(err)
})
// 响应拦截
axios.interceptors.response.use(data => {
    console.log('response', data)
    switch (data.status) {
        case 500:
            Message.error('网络错误')
            break
    }
    if (data.data.code == '500') {
        sessionStorage.removeItem('token')
        Message.error('登录超时')
        router.push({
            path: '/login',
        })
        return
    }
    return data
}, err => {
    return Promise.reject(err.response)
})


export default class api {
    /**
     * Simply a migration from legacy ajax.sendRequest method, but with new ES6 signature
     *
     * @param method HTTP method (e.g. 'GET', 'POST', etc)
     * @param url Absolute or relative URL of the resource that is being requested.
     * @param params Map of strings or objects which will be serialized with the paramSerializer and appended as GET parameters.
     * @param data Data to be sent as the request message data.
     * @param timeout timeout in milliseconds, or promise that should abort the request when resolved.
     * @param binary Whether or not to expect the response is binary
     * @param cache A boolean value or object created with $cacheFactory to enable or disable caching of the HTTP response.
     *        Typically, use this only if you know this value will not be updated.
     * @param useFormData Indicates that the data passed in should be transformed to FormData
     * @param addNamespace add namespace to params by default
     */
    static sendRequest({
        method = 'GET',
        url,
        data,
        params = {},
        timeout = 1000 * 300,
        binary = false,
        cache = false,
        useFormData = false,
        Authorization,
        responseType,
        includeHeaders = false
    }) {

        const config = {
            method,
            url,
            timeout,
            cache,
            data,
            params,
            responseType,
            useFormData,
            Authorization,
            binary,
            includeHeaders
        }
        return axios(config).then(function (response) {
            return includeHeaders ? response : response.data
        })
    }
}